// extracted by mini-css-extract-plugin
export default {"flex":"Flex_flex__4-DT-","flex-item":"Flex_flex-item__IL-Jf"};